export const foldersKeys = {
  prefix: 'folders',
  detail: (id: string) => [foldersKeys.prefix, 'detail', id],
}
